import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form } from 'reactstrap';
import { Button } from '../../../components/Component'; // Assuming Button is a shared component

const TagEditModal = ({ show, onHide, tag, onSave, isLoading }) => {
    const [tagName, setTagName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (tag) {
            setTagName(tag.name || ''); // Ensure tag.name is not undefined
        } else {
            setTagName(''); // Reset for new tag
        }
        setError(''); // Clear error when modal opens or tag changes
    }, [tag, show]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!tagName.trim()) {
            setError('Tag name cannot be empty.');
            return;
        }
        setError('');
        onSave({ id: tag ? tag.id : null, name: tagName }); // Use id if that's the identifier from backend
    };

    const handleClose = () => {
        setError('');
        setTagName('');
        onHide();
    }

    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                {tag ? 'Edit Tag' : 'Create New Tag'}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {error && <p className="text-danger">{error}</p>}
                    <FormGroup>
                        <Label htmlFor="tagName">Tag Name</Label>
                        <Input
                            type="text"
                            id="tagName"
                            value={tagName}
                            onChange={(e) => setTagName(e.target.value)}
                            placeholder="Enter tag name"
                            disabled={isLoading}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={handleClose} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" disabled={isLoading}>
                        {isLoading ? (tag ? 'Saving...' : 'Creating...') : (tag ? 'Save Changes' : 'Create Tag')}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default TagEditModal;